export const CUSTOM_CATEGORY_COMPONENT_TYPE = {
  CUSTOMER_CATEGORY: "CUSTOMER_CATEGORY",
  VENDOR_CATEGORY: "VENDOR_CATEGORY",
  SUB_CATEGORY: "SUB_CATEGORY",
};
